import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c899106"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-8" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "d-flex justify-content-end gap-5 p-3 pe-6 mb-6",
  style: {"border-bottom":"0.5px solid #f9f9f9"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-7" }, "Selecionar todos", -1))
const _hoisted_5 = {
  class: "ps-0",
  style: {"max-height":"28.5rem","overflow":"auto"}
}
const _hoisted_6 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_7 = { class: "d-flex flex-row align-items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-center",
  id: "svgg",
  style: {"width":"10rem"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "30",
    height: "30",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z",
      fill: "#E72F48"
    })
  ])
], -1))
const _hoisted_9 = { class: "d-flex flex-row gap-4 align-items-center" }
const _hoisted_10 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 576 512"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z",
  fill: "gold"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "d-flex justify-content-center align-content-center align-items-center gap-5 flex-column h-100"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "200",
  height: "120",
  viewBox: "0 0 250 175",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M166.295 87.5089C159.694 87.5089 153.483 83.9935 150.124 78.3689L125.009 36.7309L99.9321 78.3689C96.5339 84.0326 90.3233 87.548 83.7222 87.548C81.9645 87.548 80.2068 87.3136 78.5272 86.8058L25.015 71.4943V141.021C25.015 146.763 28.921 151.763 34.4675 153.13L118.915 174.261C122.899 175.238 127.079 175.238 131.024 174.261L215.55 153.13C221.096 151.724 225.002 146.724 225.002 141.021V71.4943L171.49 86.7668C169.811 87.2746 168.053 87.5089 166.295 87.5089ZM249.337 43.6836L229.221 3.52984C228.01 1.10812 225.393 -0.298043 222.698 0.0534977L125.009 12.5137L160.827 71.924C162.311 74.3848 165.28 75.5565 168.053 74.7754L245.353 52.7064C249.22 51.5737 251.094 47.2771 249.337 43.6836ZM20.7965 3.52984L0.680553 43.6836C-1.11621 47.2771 0.797733 51.5737 4.62562 52.6674L81.9254 74.7363C84.6987 75.5175 87.6673 74.3457 89.1515 71.8849L125.009 12.5137L27.2804 0.0534977C24.5853 -0.258983 22.0073 1.10812 20.7965 3.52984Z",
    fill: "#E8E8E8"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Title = _resolveComponent("Title")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.listaProdutos.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_el_switch, {
              onClick: $setup.selecionarTodosToggle,
              modelValue: $setup.selecteAll,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selecteAll) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('atualizarNumeros', $setup.listaProdutos, $setup.listaProdutos[0].match))),
              class: "ml-2",
              style: {"--el-switch-on-color":"#E72F48","--el-switch-off-color":"gray"}
            }, null, 8, ["onClick", "modelValue"])
          ]),
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listaProdutos, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["d-flex justify-content-between", { dragging: index === _ctx.draggingItem }]),
                key: index,
                ref_for: true,
                ref: "listItem",
                draggable: "true",
                onDragstart: ($event: any) => ($setup.dragStart(index, $event)),
                onDragend: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.dragEnd && $setup.dragEnd(...args))),
                onDragover: ($event: any) => ($setup.dragOver(index, $event)),
                onDrop: ($event: any) => ($setup.drop(index, $event)),
                style: {"transition":"opacity 0.3s ease","outline":"none !important","background":"white"}
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", null, _toDisplayString(item.nome), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_switch, {
                    value: item.ativo !== 'sim' ? false : true,
                    onChange: ($event: any) => {
                $setup.changeActive(item.codMarcaProduto);
                _ctx.$emit('atualizarNumeros', $setup.listaProdutos, item.match);
              },
                    class: "ml-2",
                    style: {"--el-switch-on-color":"#E72F48","--el-switch-off-color":"gray"}
                  }, null, 8, ["value", "onChange"])
                ])
              ], 42, _hoisted_6))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_Title, null, {
            default: _withCtx(() => [
              _createTextVNode("Selecione um tipo de parceiro")
            ]),
            _: 1
          }),
          _hoisted_14
        ]))
  ]))
}